import { SearchOutlined } from "@ant-design/icons";
import { Button, Form, Input } from "antd";

interface EazyRegistrationDeleteProps {
  loading: boolean;
  handleSearch: (value: string, page?: number) => void;
}

export const EazyRegistrationDelete = ({ loading, handleSearch }: EazyRegistrationDeleteProps) => {
  const form = Form.useFormInstance();

  const handlePressEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const value = (e.target as HTMLInputElement).value;
    handleSearch(value, 1);
  };

  const handleButtonClick = () => {
    const value = form.getFieldValue("name") || "";
    handleSearch(value, 1);
  };

  return (
    <div className="flex items-center">
      <Form.Item className="mb-0 mr-4 w-full max-w-[570px]" name="name">
        <Input className="max-w-[570px]" maxLength={128} onPressEnter={handlePressEnter} placeholder="棟名を検索" />
      </Form.Item>
      <Button icon={<SearchOutlined />} loading={loading} onClick={handleButtonClick} type="primary">
        検索
      </Button>
    </div>
  );
};
